/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type { Signer, ContractDeployTransaction, ContractRunner } from "ethers";
import type { NonPayableOverrides } from "../common";
import type { OrderBook, OrderBookInterface } from "../OrderBook";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "orderId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "landTokenAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "stableTokenAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "enum TransactionType",
        name: "transactionType",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "enum IOrderBook.OrderType",
        name: "orderType",
        type: "uint8",
      },
    ],
    name: "OrderBookTransaction",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "OWNER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256",
      },
    ],
    name: "cancelOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "landTokenAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "stableTokenAmount",
        type: "uint256",
      },
    ],
    name: "createPurchaseOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "landTokenAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "stableTokenAmount",
        type: "uint256",
      },
    ],
    name: "createSellOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getTokensInOrderBook",
    outputs: [
      {
        internalType: "uint256",
        name: "stableTokenInOrders",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "landTokenInOrders",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "shareLandTokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "stableTokenAddress",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256",
      },
    ],
    name: "orderById",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "owner",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "landTokenAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "stableTokenAmount",
            type: "uint256",
          },
          {
            internalType: "enum IOrderBook.OrderType",
            name: "orderType",
            type: "uint8",
          },
        ],
        internalType: "struct IOrderBook.Order",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "orders",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "ordersByAccount",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "processLimitOrders",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "shareLandMarketAddress",
        type: "address",
      },
    ],
    name: "setExternalDependencies",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type OrderBookConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: OrderBookConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class OrderBook__factory extends ContractFactory {
  constructor(...args: OrderBookConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(overrides || {});
  }
  override deploy(overrides?: NonPayableOverrides & { from?: string }) {
    return super.deploy(overrides || {}) as Promise<
      OrderBook & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): OrderBook__factory {
    return super.connect(runner) as OrderBook__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): OrderBookInterface {
    return new Interface(_abi) as OrderBookInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): OrderBook {
    return new Contract(address, _abi, runner) as unknown as OrderBook;
  }
}
